import { SnackbarManager } from '@cmg/design-system';
import React from 'react';

import { updateDemandGridRowsReactiveVar } from '../../../../../../../../order-book/institutional-demand/hooks/useUpdateDemandGridRowsReactiveVar';
import { useIndicationActivitySyndicateContext } from '../../../../../context/IndicationActivitySyndicateContext';
import { useAcknowledgeInstitutionalIndicationMutation } from '../../../../indication-form/components/indication-details/components/acknowledgement/hooks/useAcknowledgeInstitutionalIndicationMutation';
import { useUnacknowledgeInstitutionalIndicationMutation } from '../../../../indication-form/components/indication-details/components/acknowledgement/hooks/useUnacknowledgeInstitutionalIndicationMutation';

export const useIndicationAcknowledgementBanner = () => {
  const { offeringId, basicPublishedOffering } = useIndicationActivitySyndicateContext();
  const offering = basicPublishedOffering!;
  const indication = basicPublishedOffering?.orderBook.institutionalIndication!;

  const [acknowledgeIndication, { loading: isAcknowledging }] =
    useAcknowledgeInstitutionalIndicationMutation({
      offeringId,
      indicationId: indication.id,
      version: indication.version,
    });
  const [unacknowledgeIndication, { loading: isUnacknowledging }] =
    useUnacknowledgeInstitutionalIndicationMutation({
      offeringId,
      indicationId: indication.id,
      version: indication.version,
    });

  const handleAcknowledge = React.useCallback(async () => {
    try {
      await acknowledgeIndication();

      updateDemandGridRowsReactiveVar({ fetchIds: [indication.id] });
      SnackbarManager.success('Successfully acknowledged indication');
    } catch {
      SnackbarManager.error('Failed to acknowledge indication');
    }
  }, [acknowledgeIndication, indication.id]);
  const handleUnacknowledge = React.useCallback(async () => {
    try {
      await unacknowledgeIndication();

      updateDemandGridRowsReactiveVar({ fetchIds: [indication.id] });
      SnackbarManager.success('Successfully unacknowledged indication');
    } catch {
      SnackbarManager.error('Failed to unacknowledge indication');
    }
  }, [indication.id, unacknowledgeIndication]);

  return {
    isAcknowledging,
    isUnacknowledging,
    indicationVersion: indication.version,
    offering,
    offeringType: offering.type,
    indicationModifiedByFirmKey: indication.auditInfo.modifiedByFirmKey,
    onAcknowledge: handleAcknowledge,
    onUnacknowledge: handleUnacknowledge,
  };
};
